import { HStack, Text } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { ImageContainer } from '@/components/shared/displayers/ImageContainer'
import { EquipmentVista as Vista } from '@/services/backend/config/entities'

interface Props {
  data: Vista
  children?: ReactNode
}

export const ViewVistaDisplayer = ({ data, children }: Props) => {
  return (
    <HStack>
      <ImageContainer src={data.imageStr ?? undefined} size="xs" />
      <Text flex={1}>{data.name}</Text>
      {children}
    </HStack>
  )
}
